import script from "./CriticalIncidenciaBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./CriticalIncidenciaBanner.vue?vue&type=script&lang=ts&setup=true"

import "./CriticalIncidenciaBanner.vue?vue&type=style&index=0&id=05559fe9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05559fe9"]])

export default __exports__